import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { resolveVisibleSections } from "@/lib/sections";

// Section anahtar → route path (Panel'e erişimi olmayan kullanıcı için fallback)
const SECTION_ROUTES = {
  "panel": "/",
  "branches": "/branches",
  "personnel": "/personnel",
  "reports": "/reports",
  "daily-summary": "/daily-summary",
  "timesheet": "/timesheet",
  "advance-requests": "/advance-requests",
  "stock-count": "/stock-count",
  "balance": "/balance",
  "online-panel": "/online-panel",
  "merkez-daily": "/merkez-daily",
  "meal-card-payments": "/meal-card-payments",
  "audit-log": "/audit-log",
};

export default function ProtectedRoute({ children, requireAdmin = false, requireAdminOrRegional = false, requireAdminOrAccounting = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#F9F8F6]">
        <div className="text-slate-500 font-mono text-sm">Yükleniyor...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;

  // Ana sayfa isteyen kullanıcı Panel'e erişemiyorsa ilk görülebilir sayfaya
  // yönlendir. Muhasebe/Merkez odaklı kullanıcılar için giriş sonrası
  // yumuşak yönlendirme sağlar.
  if (loc.pathname === "/") {
    const visible = resolveVisibleSections(user);
    if (!visible.has("panel")) {
      const ORDER = ["merkez-daily", "meal-card-payments", "reports", "daily-summary", "timesheet", "branches", "personnel", "audit-log"];
      const firstKey = ORDER.find((k) => visible.has(k)) || Array.from(visible)[0];
      const path = firstKey && SECTION_ROUTES[firstKey];
      if (path && path !== "/") return <Navigate to={path} replace />;
    }
  }

  if (requireAdmin && user.role !== "admin") return <Navigate to="/" replace />;
  if (requireAdminOrRegional && !(user.role === "admin" || user.role === "regional_manager")) return <Navigate to="/" replace />;
  if (requireAdminOrAccounting && !(user.role === "admin" || user.role === "accounting")) return <Navigate to="/" replace />;
  return children;
}
